<template>
  <hypto-popup :title="'Event Details'" :footer="false">
    <template v-slot:body>
      <div class="status" v-if="$route.name !== 'UpcomingEvents'">
        <p v-if="eventOptions.status" class="operational">
          <i class="fa fa-check-circle" />
          Service is operational
        </p>
        <p v-else-if="eventOptions.end_time && moment(eventOptions.end_time).isBefore(moment())">
          <i class="fa fa-check-circle" />
          Resolved
        </p>
        <p v-else>
          <i class="fa" :class="{'fa-clock': eventOptions.severity !== 'Completely down', 'fa-exclamation-circle': eventOptions.severity === 'Completely down'}" />
          In progress
        </p>
      </div>

      <div v-for="(data, index) in eventDetails" :key="index" class="status-rows">
        <h6>{{data.field}}</h6>:
        <p :class="data.css">{{data.value}}</p>
      </div>

      <div v-if="eventTimings.length">
        <h5>Duration</h5>
        <div v-for="(data, index) in eventTimings" :key="index" class="status-rows">
          <h6>{{data.field}}</h6>:
          <p>{{data.value}}</p>
        </div>
      </div>

      <div v-if="eventOptions.comments && eventOptions.comments.length">
        <h5>Comments</h5>
        <div v-for="(data, index) in eventOptions.comments" :key="index" class="status-rows">
          <h6>{{data.title}}</h6>:
          <p>{{data.message}}</p>
          <i>{{moment(data.timestamp).format(dateFormat)}}</i>
        </div>
      </div>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import moment from 'moment'

export default {
  name: 'EventDetails',
  components: { HyptoPopup },
  props: {
    eventOptions: Object
  },
  data () {
    return {
      eventDetails: [],
      eventTimings: [],
      dateFormat: 'DD-MMM-YYYY, hh:mm a'
    }
  },
  created () {
    this.addDetails('Service', this.eventOptions.service)
    this.addDetails('Module', this.eventOptions.module + (this.eventOptions.additional_info ? ` (${this.eventOptions.additional_info})` : ''))

    if (!this.eventOptions.status) {
      this.addDetails('Reason', this.eventOptions.reason)
      this.addDetails('Cause', this.eventOptions.cause)
      this.addDetails('Severity', this.eventOptions.severity)
      this.addDetails('Details', this.eventOptions.details || '-')
      this.addTimings('Start Time', this.eventOptions.start_time)
      this.addTimings('End Time', this.eventOptions.end_time)
    }
  },
  methods: {
    moment,
    addDetails (field, value) {
      this.eventDetails.push({
        field, value
      })
    },
    addTimings (field, value) {
      value = this.timeFormat(value)
      this.eventTimings.push({
        field, value
      })
    },
    timeFormat (time) {
      return time ? moment(time).format(this.dateFormat) : '-'
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .status {
    border-radius: 5px;
    border: 1px solid $grey-outline;
    padding: 8px;
    margin-bottom: 10px;

    i {
      margin-right: 10px;
    }

    .operational {
      i {
        display: block;
        padding: 10px;
        color: $increase;
        margin: 0 !important;
      }
    }
  }

  .status-rows {
    display: flex;
    flex-wrap: wrap;
    margin: 5px 0;

    i {
      @include normal-text($grey-light, 13px, 400);
      width: 100%;
      text-align: left;
    }

    h6 {
      @include normal-text($grey-text, 13px, 500);
      width: 35%;
      margin-right: 10px;
      text-align: left
    }
    p {
      @include highlight-text($secondary, 13px);
      flex: 1;
      margin-left: 10px;
      text-align: left;
    }
  }

  h5 {
    padding: 4px 0;
    text-align: left;
    border-bottom: 1px solid $grey-outline;
    margin: 10px 0;
    font-weight: 400;
    font-size: 14px;
  }

  .tablet, .mobile {
    .status-rows {
      i {
        font-size: 12px !important;
      }
    }
  }
</style>
